import React from "react";
import SidebarStateContext from "./SidebarStateContext";

export default function useSidebarState() {
  const context = React.useContext(SidebarStateContext);
  if (context === undefined) {
    throw new Error("useSidebarState must be used within a SidebarProvider");
  }
  return context;
}
